import React from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import Radio2 from "../../components/Radio/Radio2";
import RadioGroup from "../../components/Radio/RadioGroup";
import Checkbox from "../../components/Checkbox/Checkbox";


const RenderHtml = (props) => {

    let dischargeHtml=<></>;


    const radioOptions = [
         {mapCd: "M05001", value: "1", label: "Yes"}, {mapCd: "M05001", value: "2", label: "No"}
        ,{mapCd: "M05004", value: "1", label: "Ischemic"}, {mapCd: "M05004", value: "2", label: "Hemorrhagic"}
        ,{mapCd: "M05010", value: "1", label: "Recovery to home"}, {mapCd: "M05010", value: "2", label: "Recovery to other hospital"}
        ,{mapCd: "M05010", value: "3", label: "Hopeless discharge"}, {mapCd: "M05010", value: "4", label: "Death"}
        ,{mapCd: "M05014", value: "1", label: "Free wall rupture"}, {mapCd: "M05014", value: "2", label: "Septal rupture"}
        ,{mapCd: "M05014", value: "3", label: "Acute MR"}
        ,{mapCd: "M05025", value: "1", label: "Yes"}, {mapCd: "M05025", value: "2", label: "No"}
        ,{mapCd: "M05025", value: "3", label: "Unknown"}
        ,{mapCd: "M05026", value: "1", label: "Yes"}, {mapCd: "M05026", value: "2", label: "No"}
        ,{mapCd: "M05026", value: "3", label: "Unknown"}
        ,{mapCd: "M05035", value: "1", label: "Yes"}, {mapCd: "M05035", value: "2", label: "No"}
        ,{mapCd: "M05035", value: "3", label: "Unknown"}
        ,{mapCd: "M05036", value: "1", label: "Yes"}, {mapCd: "M05036", value: "2", label: "No"}
        ,{mapCd: "M05036", value: "3", label: "Unknown"}
        ,{mapCd: "M05037", value: "1", label: "Warfarin (Coumadin)"},{mapCd: "M05037", value: "2", label: "Dabigatran"}
        ,{mapCd: "M05037", value: "3", label: "Apixaban"},           {mapCd: "M05037", value: "4", label: "Rivaroxaban"}
        ,{mapCd: "M05037", value: "5", label: "Edoxaban"},           {mapCd: "M05037", value: "6", label: "Other"}
        ,{mapCd: "M05041", value: "1", label: "Yes"}, {mapCd: "M05041", value: "2", label: "No"},{mapCd: "M05041", value: "3", label: "Unknown"}
        ,{mapCd: "M05042", value: "1", label: "Yes"}, {mapCd: "M05042", value: "2", label: "No"},{mapCd: "M05042", value: "3", label: "Unknown"}
        ,{mapCd: "M05043", value: "1", label: "Yes"}, {mapCd: "M05043", value: "2", label: "No"},{mapCd: "M05043", value: "3", label: "Unknown"}
        ,{mapCd: "M05044", value: "1", label: "Yes"}, {mapCd: "M05044", value: "2", label: "No"},{mapCd: "M05044", value: "3", label: "Unknown"}
        ,{mapCd: "M05045", value: "1", label: "Yes"}, {mapCd: "M05045", value: "2", label: "No"},{mapCd: "M05045", value: "3", label: "Unknown"}
        ,{mapCd: "M05046", value: "1", label: "Yes"}, {mapCd: "M05046", value: "2", label: "No"},{mapCd: "M05046", value: "3", label: "Unknown"}
        ,{mapCd: "M05047", value: "1", label: "Yes"}, {mapCd: "M05047", value: "2", label: "No"},{mapCd: "M05047", value: "3", label: "Unknown"}
        ,{mapCd: "M05048", value: "1", label: "Yes"}, {mapCd: "M05048", value: "2", label: "No"},{mapCd: "M05048", value: "3", label: "Unknown"}
        ,{mapCd: "M05049", value: "1", label: "Yes"}, {mapCd: "M05049", value: "2", label: "No"},{mapCd: "M05049", value: "3", label: "Unknown"}
        ,{mapCd: "M05050", value: "1", label: "Yes"}, {mapCd: "M05050", value: "2", label: "No"},{mapCd: "M05050", value: "3", label: "Unknown"}
        ,{mapCd: "M05051", value: "1", label: "Yes"}, {mapCd: "M05051", value: "2", label: "No"},{mapCd: "M05051", value: "3", label: "Unknown"}
        ,{mapCd: "M05052", value: "1", label: "Yes"}, {mapCd: "M05052", value: "2", label: "No"},{mapCd: "M05052", value: "3", label: "Unknown"}
        ,{mapCd: "M05053", value: "1", label: "Yes"}, {mapCd: "M05053", value: "2", label: "No"},{mapCd: "M05053", value: "3", label: "Unknown"}


    ];

    const activeFlagObj = props.activeFlagObj;

    const btnAllObj = [
         {mapCd: "M05023", tarId:"M05025", tarVal:"2"},{mapCd: "M05023", tarId:"M05026", tarVal:"2"}
        ,{mapCd: "M05023", tarId:"M05035", tarVal:"2"},{mapCd: "M05023", tarId:"M05036", tarVal:"2"}
        ,{mapCd: "M05024", tarId:"M05025", tarVal:"3"},{mapCd: "M05024", tarId:"M05026", tarVal:"3"}
        ,{mapCd: "M05024", tarId:"M05035", tarVal:"3"},{mapCd: "M05024", tarId:"M05036", tarVal:"3"}
        ,{mapCd: "M05039", tarId:"M05041", tarVal:"2"},{mapCd: "M05039", tarId:"M05042", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05043", tarVal:"2"},{mapCd: "M05039", tarId:"M05044", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05045", tarVal:"2"},{mapCd: "M05039", tarId:"M05046", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05047", tarVal:"2"},{mapCd: "M05039", tarId:"M05048", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05049", tarVal:"2"},{mapCd: "M05039", tarId:"M05050", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05051", tarVal:"2"},{mapCd: "M05039", tarId:"M05052", tarVal:"2"}
        ,{mapCd: "M05039", tarId:"M05053", tarVal:"2"}
        ,{mapCd: "M05040", tarId:"M05041", tarVal:"3"},{mapCd: "M05040", tarId:"M05042", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05043", tarVal:"3"},{mapCd: "M05040", tarId:"M05044", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05045", tarVal:"3"},{mapCd: "M05040", tarId:"M05046", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05047", tarVal:"3"},{mapCd: "M05040", tarId:"M05048", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05049", tarVal:"3"},{mapCd: "M05040", tarId:"M05050", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05051", tarVal:"3"},{mapCd: "M05040", tarId:"M05052", tarVal:"3"}
        ,{mapCd: "M05040", tarId:"M05053", tarVal:"3"}

    ];


    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );


        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                    props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
            });
        }

    }

    const btnAllEvent = (mapCd) => {
        /* 일괄 선택 처리 */
        const allObj = btnAllObj.filter(item => item.mapCd === mapCd);
        if (allObj.length > 0) {
            allObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarVal);
                activeEvent(item.tarId, item.tarVal);
            });
        }
    };


    /* Event ****************************************************************************** */

    const compValue = (mpaCd) => {
        return props.getDtlValue(mpaCd);
    }

    const compChange = (mapCd, value) => {
        props.setDtlValue(mapCd, value);
        activeEvent(mapCd, value);
    }

    /* ****************************************************************************** Event */

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };


    dischargeHtml =
        <>
            <div className={styleCom.title_wrap}>
                <h3>퇴원시 건강정보</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={3} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>In-hospital complication</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M05001')} selectedValue={compValue('M05001')}
                                                onChange={(val) => compChange('M05001', val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <Checkbox label={"Major bleeding event"}
                                              onChange={(e) => props.setDtlValue('M05002', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M05002') === '1'}
                                              isDisabled={props.getDtlValue('M05002', 'activeFlag')}/>
                                    <span className={style.cellText2}>
                                        {insertSpace(7)}(BARC Type 3이상: 3a-뚜렷한 출혈과 Hb↓3~5&lt; g/dL, 3b-뚜렷한 출혈과 Hb ↓≥5 g/dL, 3c-두개내 출혈/ 치명적 출혈)
                                    </span>
                                    <div className={style.cellFlex}>
                                        <Checkbox label={"CVA/Stroke"}
                                                  onChange={(e) => compChange('M05003', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05003') === '1'}
                                                  isDisabled={props.getDtlValue('M05003', 'activeFlag')}/>
                                        (<RadioGroup
                                        options={getOptionList('M05004')}
                                        selectedValue={compValue('M05004')}
                                        onChange={(val) => compChange('M05004', val)}
                                        disabled={props.getDtlValue('M05004', 'activeFlag')}/>)
                                    </div>
                                    <div>
                                        <Checkbox label={"Re-infarction"}
                                                  onChange={(e) => props.setDtlValue('M05005', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05005') === '1'}
                                                  isDisabled={props.getDtlValue('M05005', 'activeFlag')}/>
                                        <div style={{marginTop: "3px"}}/>
                                        <Checkbox label={"Repeat revascularization"}
                                                  onChange={(e) => props.setDtlValue('M05006', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05006') === '1'}
                                                  isDisabled={props.getDtlValue('M05006', 'activeFlag')}/>
                                        <div style={{marginTop: "3px"}}/>
                                        <Checkbox label={"Stent thrombosis"}
                                                  onChange={(e) => props.setDtlValue('M05007', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05007') === '1'}
                                                  isDisabled={props.getDtlValue('M05007', 'activeFlag')}/>
                                        <div style={{marginTop: "3px"}}/>
                                        <Checkbox label={"Atrial fibrillation / Atrial flutter"}
                                                  onChange={(e) => props.setDtlValue('M05008', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05008') === '1'}
                                                  isDisabled={props.getDtlValue('M05008', 'activeFlag')}/>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Discharge date</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getDtlValue('M05009'))}
                                    dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setDtlValue('M05009', dateToYMD(date))}/>
                    </div>
                    <div>Discharge type</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup
                                        options={getOptionList('M05010')}
                                        selectedValue={compValue('M05010')}
                                        onChange={(val) => compChange('M05010', val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className={style.cellText2}>
                                        <div className={style.cellText1}>Cause of Death</div>
                                        {insertSpace(1)}*Cardiac death:심장이 직접 원인인 사망(예. 심근경색증, 저박출성 심부전, 치명적 부 정맥), 심장이 원인이 아니라고
                                        <br/>{insertSpace(1)}명백히 입증되지 않은 한 모든 사망은 심장사로 간주됨.
                                        <br/>{insertSpace(1)}*Non-cardiac death: 감염, 패혈증, 폐 원인, 사고, 자살이나 외상으로 인한 사망을 포함해 위의 정의에 해당되지 않는 모든 사망
                                    </span>
                                    <Radio2 label="Cardiac death" value="1" selectedValue={props.getDtlValue('M05011')}
                                            onChange={(val) => compChange('M05011', val)}
                                            disabled={props.getDtlValue('M05011', 'activeFlag')}/>

                                    <div className={style.cellFlex}>
                                        <Checkbox label={"Pump failure"} marginLeft={"10px"} marginTop={"5px"}
                                                  onChange={(e) => props.setDtlValue('M05012', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05012') === '1'}
                                                  isDisabled={props.getDtlValue('M05012', 'activeFlag')}/>
                                        <Checkbox label={"Mechanical complication"} marginLeft={"10px"}
                                                  marginTop={"5px"}
                                                  onChange={(e) => compChange('M05013', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05013') === '1'}
                                                  isDisabled={props.getDtlValue('M05013', 'activeFlag')}/>
                                        (<RadioGroup
                                            options={getOptionList('M05014')}
                                            selectedValue={compValue('M05014')}
                                            onChange={(val) => compChange('M05014', val)}
                                            disabled={props.getDtlValue('M05014', 'activeFlag')}/>)
                                    </div>
                                    <div className={style.cellFlex}>
                                        <Checkbox label={"Arrhythmia"} marginLeft={"10px"} marginTop={"5px"}
                                                  marginBottom={"10px"}
                                                  onChange={(e) => props.setDtlValue('M05015', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05015') === '1'}
                                                  isDisabled={props.getDtlValue('M05015', 'activeFlag')}/>
                                        <Checkbox label={"Others"} marginLeft={"19px"} marginTop={"5px"}
                                                  marginBottom={"10px"}
                                                  onChange={(e) => compChange('M05016', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05016') === '1'}
                                                  isDisabled={props.getDtlValue('M05016', 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue('M05017')}
                                                       maxLength={30} width={"300px"}
                                                       onChange={(value) => props.setDtlValue("M05017", value)}
                                                       readOnly={props.getDtlValue('M05017', 'activeFlag')}/>
                                    </div>


                                    <Radio2 label="Non-cardiac death" value="2"
                                            selectedValue={props.getDtlValue('M05011')}
                                            onChange={(val) => compChange('M05011', val)}
                                            disabled={props.getDtlValue('M05011', 'activeFlag')}/>
                                    <div className={style.cellFlex}>

                                    </div>
                                    <div className={style.cellFlex}>
                                        <Checkbox label={"Bleeding"} marginLeft={"10px"}
                                                  onChange={(e) => props.setDtlValue('M05018', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05018') === '1'}
                                                  isDisabled={props.getDtlValue('M05018', 'activeFlag')}/>
                                        <Checkbox label={"Multi-organ failure"} marginLeft={"10px"}
                                                  onChange={(e) => props.setDtlValue('M05019', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05019') === '1'}
                                                  isDisabled={props.getDtlValue('M05019', 'activeFlag')}/>
                                    </div>


                                    <div className={style.cellFlex}>
                                        <Checkbox label={"Sepsis"} marginLeft={"10px"} marginTop={"10px"}
                                                  onChange={(e) => props.setDtlValue('M05020', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05020') === '1'}
                                                  isDisabled={props.getDtlValue('M05020', 'activeFlag')}/>
                                        <Checkbox label={"Others"} marginLeft={"40px"} marginTop={"10px"}
                                                  onChange={(e) => compChange('M05021', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05021') === '1'}
                                                  isDisabled={props.getDtlValue('M05021', 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue('M05022')}
                                                       maxLength={30} width={"300px"}
                                                       onChange={(value) => props.setDtlValue("M05022", value)}
                                                       readOnly={props.getDtlValue('M05022', 'activeFlag')}/>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                    <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <h3> Medication At Discharge <br/> Anti-platelet and Anti-coagulant</h3>
                    </span>
                        <span>
                        <div style={{display: "flex"}}>
                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnAllEvent('M05023')}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent('M05024')}>All Unknown</Button>
                        </div>
                    </span>
                    </div>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={4} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Aspirin</div>
                    <div>
                        <RadioGroup options={getOptionList('M05025')} selectedValue={compValue('M05025')}
                                    onChange={(val) => props.setDtlValue('M05025', val)}/>
                    </div>
                    <div>P2Y12 RI</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M05026')}
                                                selectedValue={props.getDtlValue('M05026')}
                                                onChange={(val) => compChange('M05026', val)}
                                                disabled={props.getDtlValue('M05026', 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>If Yes,</p>
                                    <Radio2 label="Clopidogrel" value="1"
                                            selectedValue={props.getDtlValue('M05027')}
                                            onChange={(val) => compChange('M05027', val)}
                                            disabled={props.getDtlValue('M05027', 'activeFlag')}/>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Prasugrel" value="2" selectedValue={props.getDtlValue('M05027')}
                                                onChange={(val) => compChange('M05027', val)}
                                                disabled={props.getDtlValue('M05027', 'activeFlag')}/>
                                        (<Checkbox label={"10mg qd"}
                                                   onChange={(e) => props.setDtlValue('M05028', e.target.checked ? '1' : '0')}
                                                   checked={props.getDtlValue('M05028') === '1'}
                                                   isDisabled={props.getDtlValue('M05028', 'activeFlag')}/>
                                        <Checkbox label={"5mg qd"}
                                                  onChange={(e) => props.setDtlValue('M05029', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05029') === '1'}
                                                  isDisabled={props.getDtlValue('M05029', 'activeFlag')}/>)
                                    </div>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Ticagrelor" value="3" selectedValue={props.getDtlValue('M05027')}
                                                onChange={(val) => compChange('M05027', val)}
                                                disabled={props.getDtlValue('M05027', 'activeFlag')}/>
                                        (<Checkbox label={"90mg qd"}
                                                   onChange={(e) => props.setDtlValue('M05030', e.target.checked ? '1' : '0')}
                                                   checked={props.getDtlValue('M05030') === '1'}
                                                   isDisabled={props.getDtlValue('M05030', 'activeFlag')}/>
                                        <Checkbox label={"90mg bid"}
                                                  onChange={(e) => props.setDtlValue('M05031', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05031') === '1'}
                                                  isDisabled={props.getDtlValue('M05031', 'activeFlag')}/>
                                        <Checkbox label={"60mg bid"}
                                                  onChange={(e) => props.setDtlValue('M05032', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05032') === '1'}
                                                  isDisabled={props.getDtlValue('M05032', 'activeFlag')}/>
                                        <Checkbox label={"45mg bid"}
                                                  onChange={(e) => props.setDtlValue('M05033', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M05033') === '1'}
                                                  isDisabled={props.getDtlValue('M05033', 'activeFlag')}/>)

                                    </div>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Other" value="4" selectedValue={props.getDtlValue('M05027')}
                                                onChange={(val) => compChange('M05027', val)}
                                                disabled={props.getDtlValue('M05027', 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue('M05034')} unit={""}
                                                       maxLength={30} width={"300px"}
                                                       onChange={(value) => props.setDtlValue("M05034", value)}
                                                       readOnly={props.getDtlValue("M05034", 'activeFlag')}/>
                                    </div>



                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Cilostazol</div>
                    <div>
                        <RadioGroup options={getOptionList('M05035')}
                                    selectedValue={props.getDtlValue('M05035')}
                                    onChange={(val) => props.setDtlValue('M05035', val)}/>
                    </div>
                    <div>Anti-coagulant</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M05036')}
                                                selectedValue={compValue('M05036')}
                                                onChange={(val) => compChange('M05036', val)}
                                                disabled={props.getDtlValue("M05036", 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div className={style.cellFlex}>
                                        <RadioGroup options={getOptionList('M05037')} colCnt={3}
                                                    selectedValue={compValue('M05037')}
                                                    onChange={(val) => compChange('M05037', val)}
                                                    disabled={props.getDtlValue("M05037", 'activeFlag')}/>
                                        <InputUnitText marginTop={"40px"} maxLength={30} width={"300px"}
                                                       type={"text"} value={props.getDtlValue("M05038")} unit={""}
                                                       onChange={(value) => props.setDtlValue("M05038", value)}
                                                       readOnly={props.getDtlValue("M05038", 'activeFlag')}/>
                                    </div>

                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>

                </Table>
            </div>


            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <h3>Other Concomitant Medication</h3>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnAllEvent('M05039')}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent('M05040')}>All Unknown</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={9} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Beta Blocker</div>
                    <div>
                        <RadioGroup options={getOptionList('M05041')}
                                    selectedValue={props.getDtlValue('M05041')}
                                    onChange={(val) => props.setDtlValue('M05041', val)}/>
                    </div>
                    <div>CCB: Dihydropyridine</div>
                    <div>
                        <RadioGroup options={getOptionList('M05042')}
                                    selectedValue={props.getDtlValue('M05042')}
                                    onChange={(val) => props.setDtlValue('M05042', val)}/>
                    </div>
                    <div>ARB</div>
                    <div >
                        <RadioGroup options={getOptionList('M05043')}
                                    selectedValue={props.getDtlValue('M05043')}
                                    onChange={(val) => props.setDtlValue('M05043', val)}/>
                    </div>
                    <div>
                        CCB:Non-dihydropyridine
                        <br/>(Verapamil/ Diltiazem)
                    </div>
                    <div>
                        <RadioGroup options={getOptionList('M05044')}
                                    selectedValue={props.getDtlValue('M05044')}
                                    onChange={(val) => props.setDtlValue('M05044', val)}/>
                    </div>
                    <div>ACE inhibitor</div>
                    <div className={'col_merge'}>
                        <RadioGroup options={getOptionList('M05045')}
                                    selectedValue={props.getDtlValue('M05045')}
                                    onChange={(val) => props.setDtlValue('M05045', val)}/>
                    </div>
                    <div>Statin</div>
                    <div>
                        <RadioGroup options={getOptionList('M05046')}
                                    selectedValue={props.getDtlValue('M05046')}
                                    onChange={(val) => props.setDtlValue('M05046', val)}/>
                    </div>
                    <div>Ezetimibe</div>
                    <div>
                        <RadioGroup options={getOptionList('M05047')}
                                    selectedValue={props.getDtlValue('M05047')}
                                    onChange={(val) => props.setDtlValue('M05047', val)}/>
                    </div>
                    <div>Fibrate</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('M05048')}
                                    selectedValue={props.getDtlValue('M05048')}
                                    onChange={(val) => props.setDtlValue('M05048', val)}/>
                    </div>
                    <div>Nitroglycerin</div>
                    <div>
                        <RadioGroup options={getOptionList('M05049')}
                                    selectedValue={props.getDtlValue('M05049')}
                                    onChange={(val) => props.setDtlValue('M05049', val)}/>
                    </div>
                    <div>Nicorandil</div>
                    <div>
                        <RadioGroup options={getOptionList('M05050')}
                                    selectedValue={props.getDtlValue('M05050')}
                                    onChange={(val) => props.setDtlValue('M05050', val)}/>
                    </div>
                    <div>Trimetazidine</div>
                    <div>
                        <RadioGroup options={getOptionList('M05051')}
                                    selectedValue={props.getDtlValue('M05051')}
                                    onChange={(val) => props.setDtlValue('M05051', val)}/>
                    </div>
                    <div>Diuretics</div>
                    <div>
                        <RadioGroup options={getOptionList('M05052')}
                                    selectedValue={props.getDtlValue('M05052')}
                                    onChange={(val) => props.setDtlValue('M05052', val)}/>
                    </div>
                    <div>PPI or P-cab</div>
                    <div className={'col_merge'}>
                        <RadioGroup options={getOptionList('M05053')}
                                    selectedValue={props.getDtlValue('M05053')}
                                    onChange={(val) => props.setDtlValue('M05053', val)}/>
                    </div>
                </Table>
            </div>


        </>
    ;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T7") {
        renderHtml = dischargeHtml;

    } else {
        renderHtml = <>준비중 입니다.</>;
    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

